import { Component, OnInit } from '@angular/core';
import { NewsServiceService } from 'src/app/service/news-service.service';

interface BlogPost {
  id: number;
  newsTitle: string;
  newsDesciption: string;
  imageUrl: string;
}

@Component({
  selector: 'app-home-demo-three',
  templateUrl: './home-demo-three.component.html',
  styleUrls: ['./home-demo-three.component.scss']
})
export class HomeDemoThreeComponent implements OnInit {
   singleBlogPost: BlogPost[] = [];
  ///singleBlogPost:[];
  constructor(private newsService:NewsServiceService) {
      this.newsService.getAllDetails().subscribe(res=>{
          let data = res;
          this.singleBlogPost= data.sort((a, b) => b.id - a.id);
          console.log(" this.singleBlogPost "+JSON.stringify( this.singleBlogPost));
      })
   }

  ngOnInit(): void {
  }

  sectionTitle = [
    {
        title: "Our Latest News",
       // paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida."
    }
]


}
